import { render, staticRenderFns } from "./ListSoftware.vue?vue&type=template&id=3fd487a5&scoped=true&"
import script from "./ListSoftware.vue?vue&type=script&lang=js&"
export * from "./ListSoftware.vue?vue&type=script&lang=js&"
import style0 from "./ListSoftware.vue?vue&type=style&index=0&id=3fd487a5&scoped=true&lang=css&"
import style1 from "./ListSoftware.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd487a5",
  null
  
)

export default component.exports